<template>
   <div class="_margin-bottom-30">
      <h5>Confirm & Switch</h5>
      <ul class="bullet-points _margin-bottom-30">
         <li>You will recieve a confirmation of your application to switch.</li>
         <li>Your application to switch will be sent to <span class="font-primary">{{ switchPlan.supplierName }}</span>.
         </li>
         <li><span class="font-primary">{{ switchPlan.supplierName }}</span> will get in touch with you to tell you the
            date when your switch will take
            place. It can take up to 5 to 10 working days.</li>
         <li>Take a final meter reading on the day of your switch</li>
         <li>Remember to pay your final bill to your old energy supplier</li>
      </ul>

      <p>
         Your cancellation rights are stated in the supplier's terms and conditions so please read these in full should
         you wish to do so.
         For clarity please note that the period during which you have a right to cancel your energy contract (cooling
         off period) expires 14
         days from the date on which you receive your welcome pack from <b class="font-primary">{{
            switchPlan.supplierName }}</b>.
      </p>

      <p>
         By selecting <b>'Complete Switch'</b> you are confirming that it is your intention to transfer your supply of
         energy over to the new
         supplier selected and that you have read the terms and conditions. You are also confirming that you understand
         your obligations
         to pay for your energy in accordance with the supplier's terms and conditions and at the prices outlined in the
         Tariff Information Label.
         For more information please see sections 14 and 30 of <a
            href="https://www.legislation.gov.uk/uksi/2013/3134/made" target="_blank">The Consumer Contracts Regulations
            2013</a>
      </p>

      <div id="error">
         <uiv-alert type="danger" v-if="error == 'customer'">
            <b>Error</b> <br />
            Customer details could not be saved.
         </uiv-alert>

         <uiv-alert type="danger" v-if="error == 'address'">
            <b>Error</b> <br />
            Address details could not be saved.
         </uiv-alert>

         <uiv-alert type="danger" v-if="error == 'terms'">
            <b>Error</b> <br />
            Supplier terms could not be saved.
         </uiv-alert>

         <uiv-alert type="danger" v-if="error == 'verify bank'">
            <b>Error</b> <br />
            We could not verify your bank details.
         </uiv-alert>

         <uiv-alert type="danger" v-if="error == 'bank'">
            <b>Error</b> <br />
            Bank details could not be saved.
         </uiv-alert>

         <uiv-alert type="danger" v-if="error == 'switch'">
            <b>Error</b> <br />
            Switch could not be completed. Please contact the administrator.
         </uiv-alert>
      </div>

      <div class="sticky-footer">
         <div class="col-xs-5">
            <uiv-btn type="link" block @click="goToQuestion('payment')">Back</uiv-btn>
         </div>
         <div class="col-xs-7">
            <uiv-btn type="primary" block @click="onCompleteSwitch">Complete Switch</uiv-btn>
         </div>
      </div>
   </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';

export default {
   name: 'Confirm',
   data() {
      return {
         error: null
      }
   },
   computed: {
      ...mapState({
         app_settings: ({ app_settings }) => app_settings,
         switchPlan: ({ personal_details_switch_plan }) => personal_details_switch_plan
      })
   },
   methods: {
      ...mapActions({
         goToQuestion: 'personal_details_questions/goToQuestion'
      }),
      async onCompleteSwitch() {
         const { payMethod } = this.switchPlan;
         this.error = null;

         this.$store.dispatch('page_loader/start', 0);
         this.$store.dispatch('tracing/addAction', { name: 'Action', value: 'Complete & Switch' });

         try {
            await this.$store.dispatch('personal_details_customer/update');
            await this.$store.dispatch('personal_details_address/update');
            await this.$store.dispatch('personal_details_terms/update');

            if (payMethod == 'MonthlyDirectDebit' || payMethod == 'QuaterlyDirectDebit') {
               await this.$store.dispatch('personal_details_payment/verifyBankDetails');
               await this.$store.dispatch('personal_details_payment/update');
            }

            await this.$store.dispatch('personal_details_switch_plan/completeSwitch');
            await this.$store.dispatch('tracing/saveActions');
         } catch (error) {
            this.$store.dispatch('tracing/addAction', { name: 'Page', value: 'Confirmation & Switch' });
            this.$store.dispatch('tracing/addAction', { name: 'Error Page', value: error.status });
            await this.$store.dispatch('tracing/saveActions');

            this.error = error;

            this.$nextTick(() => {
               this.$scrollTo('#error');
            });

         } finally {
            this.$store.dispatch('page_loader/stop');
         }
      }
   }
};
</script>

<style lang="scss"></style>
